import { AnyBlock, Block, BlockType, Point2D, Size } from "../types";
import { v4 as uuidv4 } from "uuid";
import { DEFAULT_BLOCK_SIZE } from "../consts";
import { nextUpdatedAt } from "../utils/updatedAt";

function createBlock(
  type: BlockType,
  position: Point2D = {
    x: 0,
    y: 0,
  },
  size: Size = DEFAULT_BLOCK_SIZE,
  value: string | null = null
) {
  if (size.width === 0 || size.height === 0 || position.x < 0 || position.y < 0)
    return;

  // For JSON text block, null value is transformed to an empty JSON doc
  let blockValue = value;
  if (type === "text/json") {
    if (blockValue === null)
      blockValue = JSON.stringify({ type: "doc", content: [] });
  }

  const block: Block = {
    id: uuidv4(),
    position: position,
    size: size,
    updatedAt: nextUpdatedAt(),
    madeBy: undefined, // This gets set in upsertBlock
    type: type,
    value: blockValue,
  };
  return block as AnyBlock;
}

export default createBlock;
export { createBlock };
